import React from 'react';
import ReactDOM from 'react-dom';
import './Assets/css/index.css';
import App from './Components/App';

ReactDOM.render(
    <App />, 
    document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js